<template>
  <validation-observer ref="provider-profile-form">
    <b-form class="p-2" @submit.prevent>
      <b-row>
        <b-col sm="12" md="6">
          <b-row>
            <b-col v-show="numberVisible" sm="6">
              <b-form-group label="Número" label-for="provider-number">
                <b-form-input
                  :value="number"
                  name="provider-number"
                  type="number"
                  plaintext
                />
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <validation-provider
                v-slot="validationContext"
                name="CIF"
                rules="required|min:9"
              >
                <b-form-group label="CIF" label-for="provider-cif">
                  <b-form-input
                    :value="model.cif"
                    name="provider-cif"
                    placeholder="cif"
                    :state="$getValidationState(validationContext)"
                    @keydown="checkInput"
                    @input="update('cif', $event)"
                  />
                  <small class="text-danger">{{
                    validationContext.errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                v-slot="validationContext"
                name="Nombre fiscal"
                rules="required"
              >
                <b-form-group
                  label="Nombre fiscal"
                  label-for="provider-fiscal-name"
                >
                  <b-form-input
                    :value="model.name"
                    name="provider-fiscal-name"
                    placeholder="Nombre fiscal"
                    :state="$getValidationState(validationContext)"
                    @input="update('name', $event)"
                  />
                  <small class="text-danger">{{
                    validationContext.errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                v-slot="validationContext"
                name="Nombre comercial"
              >
                <b-form-group
                  label="Nombre comercial"
                  label-for="provider-commercial-name"
                >
                  <b-form-input
                    :value="model.commercial_name"
                    name="provider-commercial-name"
                    placeholder="Nombre comercial"
                    :state="$getValidationState(validationContext)"
                    @input="update('commercial_name', $event)"
                  />
                  <small class="text-danger">{{
                    validationContext.errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <b-form-group label="Teléfono" label-for="provider-phone">
                <b-form-input
                  :value="model.phone"
                  name="provider-phone"
                  placeholder="Teléfono"
                  @input="update('phone', $event)"
                />
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <validation-provider
                v-slot="validationContext"
                name="Código postal"
                rules="required"
              >
                <b-form-group label="CP" label-for="postal-code">
                  <b-form-input
                    :value="model.post_code"
                    name="postal-code"
                    type="number"
                    placeholder="Código postal"
                    :state="$getValidationState(validationContext)"
                    @input="update('post_code', $event)"
                  />
                  <small class="text-danger">{{
                    validationContext.errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col sm="12">
              <validation-provider
                v-slot="validationContext"
                name="Dirección"
                rules="required"
              >
                <b-form-group label="Dirección" label-for="provider-address">
                  <b-form-input
                    :value="model.address"
                    name="provider-address"
                    placeholder="Direción"
                    :state="$getValidationState(validationContext)"
                    @input="update('address', $event)"
                  />
                  <small class="text-danger">{{
                    validationContext.errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                v-slot="validationContext"
                name="País"
                rules="required"
              >
                <b-form-group label="País" label-for="provider-country">
                  <BaseSelect
                    id="provider-country"
                    :value="model.country"
                    :resource="$data.$constants.RESOURCES.RESOURCE_COUNTRIES"
                    http-method="get"
                    @input="handleCountryInput"
                  />
                  <small class="text-danger">{{
                    validationContext.errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <b-form-group label="Provincia" label-for="provider-province">
                <v-select
                  label="name"
                  :value="model.province"
                  :options="provinceOptions"
                  @option:selected="update('province', $event)"
                />
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <validation-provider
                v-slot="validationContext"
                name="Ciudad"
                rules="required"
              >
                <b-form-group label="Ciudad" label-for="provider-city">
                  <b-form-input
                    :value="model.population"
                    name="provider-city"
                    placeholder="Ciudad"
                    :state="$getValidationState(validationContext)"
                    @input="update('population', $event)"
                  />
                  <small class="text-danger">{{
                    validationContext.errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Actividad" label-for="provider-activity">
                <BaseSelect
                  id="provider-activity"
                  :value="model.activity"
                  :resource="$data.$constants.RESOURCES.RESOURCE_ACTIVITIES"
                  http-method="get"
                  @input="update('activity', $event)"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col sm="12" md="6">
          <b-row>
            <b-col sm="12">
              <b-form-group label="Email" label-for="provider-email">
                <b-form-input
                  :value="model.email"
                  name="provider-email"
                  placeholder="Email"
                  @input="update('email', $event)"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group label="Estado" label-for="provider-status">
                <StatusSelect
                  :value="model.status"
                  :type="statusType"
                  @input="update('status', $event)"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                label="Observaciones"
                label-for="provider-observations"
              >
                <b-form-textarea
                  :value="model.observations"
                  name="provider-observations"
                  placeholder="Observaciones"
                  rows="4"
                  max-rows="4"
                  @input="update('observations', $event)"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group label="Imagen proveedor" label-for="provider-image">
                <BaseImageFileInput
                  id="provider-image"
                  :value="providerImage"
                  @input="update('image', [$event])"
                  @delete-image="imageRemoved = true"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { PROVIDER_STATUS_TYPE } from "@/api/status-api";
import FormMixin from "@/mixins/formMixin";
import StatusSelect from "@/components/status/select/StatusSelect.vue";
import BaseSelect from "@/components/ui/select/BaseSelect.vue";
import BaseImageFileInput from "@/components/ui/file/BaseImageFileInput.vue";
import ProvincesApi from "@/api/provinces-api";

export default {
  name: "ProviderProfileForm",
  components: {
    BaseImageFileInput,
    BaseSelect,
    StatusSelect,
  },
  mixins: [FormMixin],
  props: {
    numberVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusType: PROVIDER_STATUS_TYPE,
      imageRemoved: false,
      provinceOptions: [],
    };
  },
  watch: {
    async "model.country"(value) {
      const response = await ProvincesApi.list({
        page: 1,
        filters: { country_id: value.id },
      });
      this.provinceOptions = response.data;
    },
  },
  computed: {
    number() {
      return this.provider ? this.provider.number : null;
    },
    providerImage() {
      if (this.model.image) {
        return this.model.image.path || this.model.image;
      }

      return null;
    },
  },
  methods: {
    validateForm() {
      return this.$refs["provider-profile-form"].validate();
    },
    isImageRemoved() {
      return this.imageRemoved;
    },
    handleCountryInput(country) {
      this.update("country", country);
      // this.$refs["provider-province-select"].loadData({ country });
    },
    checkInput(event) {
      // Definimos los caracteres permitidos: letras, números, y guiones
      const regex = /^[a-zA-Z0-9]+$/;
      const key = event.key;

      // Permitimos teclas especiales (borrar, tab, etc.)
      if (event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 37 || event.keyCode === 39) {
        return true;
      }

      // Si la tecla presionada no pasa el regex, cancelamos la entrada
      if (!regex.test(key)) {
        event.preventDefault();
      }
    },
  },
};
</script>

<style scoped></style>
